import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';

import visualActions from '../actions/visualActions';

const defaultState = {};

export default handleActions({
    [visualActions.initVisual]: (state, { payload: { section, value } }) => state.setIn([section], fromJS(value)),
    [visualActions.setVisual]: (state, { payload: { section, key, value } }) => state.setIn([section, key], fromJS(value)),
    [visualActions.unsetVisual]: (state, { payload: { section, key } }) => state.deleteIn([section, key]),
}, fromJS(defaultState));



// WEBPACK FOOTER //
// ./src/redux/reducers/visualReducer.js